module.exports = __webpack_public_path__ + "img/p2@3x.03c96ff6.png";